import createApi from '@/services/Api';

function Patient() {
  const api = createApi();

  function searchByName(patientName) {
    const endpoint = `/profissional-saude/pacientes`;
    return api.get(endpoint, {
      params: {
        nomePaciente: patientName,
        tamanhoPagina: 10,
        nroPagina: 1,
      },
    });
  }

  return {
    searchByName,
  };
}

export default Patient();
